var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticallyresize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1311_1677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91063 7.37142L4.44188 7.37142L6.10688 5.6833L4.90438 4.45767L1.18126 8.22705L4.90438 11.9733L6.10688 10.7477L4.41876 9.1058L7.91063 9.1058L7.91063 7.37142Z",
    fill: "white",
    stroke: "#0C4284",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76062 0.734543L11.3562 0.734543L11.3562 15.812L9.76062 15.812L9.76062 0.734543Z",
    fill: "white",
    stroke: "#0C4284",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2063 0.734543L14.8019 0.734543L14.8019 15.812L13.2063 15.812L13.2063 0.734543Z",
    fill: "white",
    stroke: "#0C4284",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3813 8.22704L19.6581 4.48079L18.4325 5.70641L20.1438 7.34829L16.6519 7.34829L16.6519 9.08266L20.1438 9.08266L18.4325 10.7708L19.6581 11.9964L23.3813 8.22704Z",
    fill: "white",
    stroke: "#0C4284",
    strokeWidth: 0.55
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1311_1677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 24,
    fill: "white",
    transform: "translate(24 0.000183105) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticallyresize);
export default __webpack_public_path__ + "static/media/verticallyresize.7dc1fd38484a1fc04b3982b89bd7b061.svg";
export { ForwardRef as ReactComponent };